module.exports = __webpack_public_path__ + "img/logo10.6e46f863.png";